<template>
  <div>
    <!-- 流程出库 -->
    <!-- 顶部搜索框 -->
    <div class="usertop">
      <!-- 左侧搜索 -->
      <div>

        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-input class="w-208" :maxlength="30" v-model="formInline.drug_name" clearable placeholder="名称/拼音">
              <template #suffix>
                <div class="searchcss">
                  <i class="fa fa-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="批号">
            <el-input v-model="formInline.batch_no" clearable />
          </el-form-item>
          <el-form-item label="供货单位">
            <el-select v-model="formInline.supplier" placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="formInline.check_status" clearable placeholder="请选择">
              <el-option v-for="item in check_statusList" :key="item.id" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退库时间">
            <el-date-picker v-model="formInline.backoff_time" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD" @change="timeChange" />
          </el-form-item>
          <el-form-item label="审核时间">
            <el-date-picker v-model="formInline.backoff_check_time" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD" @change="timeChanges" />
          </el-form-item>
          <el-form-item label="退库单号">
            <el-input v-model="formInline.backoff_order_no"
              @input="(v)=>(formInline.backoff_order_no = v.replace(/[\u4E00-\u9FA5]/g, ''))" clearable />
          </el-form-item>
        </el-form>
        <el-button class="color-main" type="primary" @click="search()">
          <i class="fa fa-search"></i>查询
        </el-button>
        <el-button class="color-main" @click="resetForm" type="primary">
          <i class="fa fa-refresh"></i>重置
        </el-button>
        <el-button type="success" plain @click="checkRk">
          <i class="fa fa-plus"></i>新增退库单
        </el-button>
      </div>
    </div>
    <!-- <div class="tooltipSet">
      <div>还有<span class="red">{{totalNum}}</span>个未审核通过</div>
      <div>请您及时审核，避免影响库存数量或其他功能</div>
    </div> -->
    <!-- 表格内容 -->
    <div>
      <el-table v-loading="loading" ref="multipleTableRef" :data="tableData" style="width: 100%" max-height="56vh"
        border @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column width="130" prop="backoff_order" label="退库单号" />
        <el-table-column property="backoff_time" width="180" label="退库时间" />
        <el-table-column property="backoff_operator" label="退库人" />
        <el-table-column property="remark" label="备注" />
        <el-table-column prop="supplier" width="200" label="供货单位" show-overflow-tooltip />
        <el-table-column property="check_operator" width="80" align="center" label="审核人" />
        <el-table-column prop="check_time" label="审核时间" width="180" />
        <el-table-column prop="check_status" align="center" width="100" label="审核状态">
          <template #default="scope">
            <el-tooltip class="box-item" effect="dark" :content="scope.row.check_reason" placement="top">
              <el-link
                v-if="scope.row.check_reason!=''">{{scope.row.check_status==1?'待审核':scope.row.check_status==2?'通过':scope.row.check_status==3?'驳回':scope.row.check_status==0?'已撤销':'-'}}</el-link>
            </el-tooltip>
            <el-link
              v-if="scope.row.check_reason==''">{{scope.row.check_status==1?'待审核':scope.row.check_status==2?'通过':scope.row.check_status==3?'驳回':scope.row.check_status==0?'已撤销':'-'}}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="check_reason" align="center" label="审核意见" /> -->
        <el-table-column prop="buy_total" align="center" width="100" label="采购总价" />
        <el-table-column fixed="right" label="操作" align="center" width="180">
          <template #default="scope">
            <div class="display_flex" style="align-items: center;">
              <el-link type="success" @click="doSomeThing(scope.row,3)"
                v-if="scope.row.check_status!=2 && scope.row.check_status!=0">审核</el-link>
              <el-link type="primary" @click="doSomeThing(scope.row,2)"
                v-if="scope.row.check_status!=2 && scope.row.check_status!=0">修改</el-link>
              <el-link type="danger" @click="delParient(scope.row)"
                v-if="scope.row.check_status!=2 && scope.row.check_status!=0">撤销</el-link>
              <el-link @click="doSomeThing(scope.row,1)">
                详情
              </el-link>
              <el-link @click="exportTable(scope.row)">
                导出
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
          :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalSum" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <checkTK ref="checkTKRef" @refreshDataList="tobody"></checkTK>
    <addTK ref="addTKRef" @refreshDataList="tobody"></addTK>
    <editTK ref="editTKRef" @refreshDataList="tobody"></editTK>
    <checkedRk ref="checkedRkRef" @refreshDataList="TKClick"></checkedRk>
    <checkOrEditTk ref="checkOrEditTkRef" @refreshDataList='tobody'></checkOrEditTk>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted } from 'vue'
  import service from '@/utils/request'
  import addTK from './addTK'
  // import checkTK from './/checkPD'
  import checkedRk from './checkedRk'
  import editTK from './editTk'
  import checkOrEditTk from './checkOrEditTk'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime, getFirstDayOfMonth } from '@/utils/tool'
  export default {
    components: {
      // checkTK,
      addTK,
      checkedRk,
      checkOrEditTk,
      editTK
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1) {
      const state = reactive({
        formInline: {
          backoff_time: '',
          backoff_check_time: '',
        },
        loading: true,
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        supplierList: [],
        tableData: [],
        editTKRef: null,
        checkTKRef: null,
        checkOrEditTkRef: null,
        addTKRef: null,
        checkedRkRef: null,
        check_statusList: [{
          name: '全部',
          code: ''
        }, {
          name: '待审核',
          code: '1'
        }, {
          name: '通过',
          code: '2'
        }, {
          name: '驳回',
          code: '3'
        }, {
          name: '撤销',
          code: '0'
        }],
        totalNum: 0,
      })
      onMounted(() => {
        state.formInline.backoff_time = [getFirstDayOfMonth(), TimestampToTime()]
        // state.formInline.backoff_check_time = [getFirstDayOfMonth(), TimestampToTime()]
      })
      const getSuire = async () => {
        let res = await service.post('/api/store_enter_record/allsupplier')
        if (res.code === 0) {
          state.supplierList = res.data
        }
      }
      const resetForm = () => {
        for (const key in state.formInline) {
          state.formInline[key] = ''
        }
        state.formInline.backoff_time = [getFirstDayOfMonth(), TimestampToTime()]
        // state.formInline.backoff_check_time = [getFirstDayOfMonth(), TimestampToTime()]
        tobody()
      }
      // 获取列表
      const tobody = async () => {
        state.loading = true
        let data = {
          size: state.pageData.pageSize,
          current: state.pageData.currentPage,
          backoff_time: state.formInline.backoff_time,
          backoff_check_time: state.formInline.backoff_check_time,
          drug_name: state.formInline.drug_name,
          dict_catalog_type: props1.dictCatalogType,
          supplier: state.formInline.supplier,
          batch_no: state.formInline.batch_no,
          check_status: state.formInline.check_status,
          backoff_order_no: state.formInline.backoff_order_no
        }
        let res = await service.post('/api/backoff/backoffList', data)
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.list
            state.pageData.totalSum = res.data.total
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
          }
        }
        state.loading = false
      }
      // 条数改变时
      const handleSizeChange = (e) => {
        state.pageData.pageSize = e
        tobody()
      }
      // 页数改变时
      const handleCurrentChange = (e) => {
        state.pageData.currentPage = e
        tobody()
      }
      // 查询
      const search = () => {
        tobody()
      }
      const timeChange = (val) => {
        state.formInline.backoff_time = val
      }
      const timeChanges = (val) => {
        state.formInline.backoff_check_time = val
      }
      // 导出
      const exportTable = (row) => {
        let data = {
          backoff_order_no: row.backoff_order,
          dict_catalog_type: props1.dictCatalogType
        }
        let time = TimestampToTime()
        let title = ''
        if (props1.dictCatalogType == '160000000') {
          title = `科室药品退库.xlsx`
        } else {
          title = `科室耗材退库.xlsx`
        }
        downLoadXlsx('/api/backoff/exportBackoff', data, title)
      }
      //新增退库单
      const checkRk = () => {
        state.checkedRkRef.initData(props1.dictCatalogType)
      }
      //选择入库单后
      const TKClick = (e) => {
        let data = {
          ...e,
          record_order: e.order_no,
          dictCatalogType: props1.dictCatalogType
        }
        state.addTKRef.initData(data)
      }
      // 删除
      const delParient = (item) => {
        ElMessageBox.confirm('撤销退库单，是否确认撤销？', '操作提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await service.post('/api/backoff/cancelBackoff', {
              backoff_order_no: item.backoff_order,
            })
            if (res.code >= 0) {
              ElMessage.success(res.msg)
              tobody()
            }
          })
          .catch(() => { })
      }
      const doSomeThing = (row, type) => {
        if (type == 2) {
          let data = {
            ...row,
            dictCatalogType: props1.dictCatalogType,
            modalName: 'TK'
          }
          state.editTKRef.initData(data, type)
        } else {
          let data = {
            ...row,
            dictCatalogType: props1.dictCatalogType,
            modalName: 'TK'
          }
          state.checkOrEditTkRef.initData(data, type)
        }

      }
      return {
        ...toRefs(state),
        tobody,
        handleSizeChange,
        handleCurrentChange,
        search,
        timeChange,
        timeChanges,
        exportTable,
        TKClick,
        checkRk,
        doSomeThing,
        resetForm,
        delParient,
        getSuire
      }
    },
  }
</script>

<style scoped lang="scss">
  .displya_flex {
    display: flex;
    justify-content: space-between;
  }

  .usertop {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;

    &:deep(.el-alert--warning.is-light) {
      background-color: rgba(49, 102, 174, 0.1);
      color: #3166ae;
    }
  }

  .tabctext {
    height: 20px;
    overflow: hidden;
    cursor: pointer;
    color: rgba(49, 102, 174, 1);
  }

  .tooltipSet {
    display: flex;
    justify-content: end;
    flex-direction: column;
    font-size: 14px;
    color: #333;
    text-align: right;

    .red {
      color: red;
      font-size: 28px;
      margin: 4px;
    }
  }
</style>